.itemBullet {
  background-color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-secondary-2));
  border-color: light-dark(var(--mantine-color-gray-3), var(--mantine-color-secondary-2));
}
